var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoAdvantage2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1584 32.9713C39.5309 31.3546 39.5309 28.7333 41.1584 27.1166C42.786 25.4999 45.4249 25.4999 47.0525 27.1166C48.6801 28.7333 48.6801 31.3546 47.0525 32.9713C45.4249 34.588 42.786 34.588 41.1584 32.9713Z",
    fill: "#FFBDCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7523 35.8078C42.5218 37.1801 42.9611 38.7607 42.9611 40.4405V47.048H50.6963V41.9238C50.6963 38.3078 47.7457 35.377 44.1054 35.377C43.2761 35.377 42.4823 35.5293 41.7516 35.8078H41.7523Z",
    fill: "#FFBDCD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6433 32.9723C18.0157 31.3555 18.0157 28.7343 19.6433 27.1176C21.2709 25.5009 23.9098 25.5009 25.5374 27.1176C27.1649 28.7343 27.1649 31.3555 25.5374 32.9723C23.9098 34.589 21.2709 34.589 19.6433 32.9723Z",
    fill: "#FFBDCD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9441 35.8078C24.1746 37.1801 23.7353 38.7607 23.7353 40.4405V47.048H16.0001V41.9238C16.0001 38.3078 18.9507 35.377 22.591 35.377C23.4203 35.377 24.2141 35.5293 24.9448 35.8078H24.9441Z",
    fill: "#FFBDCD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0425 25.9797C27.567 23.0698 29.5563 20.3279 32.4858 19.8556C35.4153 19.3832 38.1757 21.3593 38.6512 24.2692C39.1267 27.1791 37.1374 29.921 34.2079 30.3933C31.2784 30.8657 28.518 28.8896 28.0425 25.9797Z",
    fill: "#FFBDCD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.851 40.4407V47.0483H41.8452V40.4407C41.8452 38.9312 41.4462 37.5147 40.7481 36.2885C39.2881 33.7278 36.5207 31.999 33.3474 31.999C30.1741 31.999 27.4067 33.7278 25.9467 36.2898C25.2493 37.5154 24.851 38.9326 24.851 40.4407Z",
    fill: "#FFBDCD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAdvantage2);
export default __webpack_public_path__ + "static/media/ico_advantage2.9589d1109e8b577f4cd2bde25dbc8820.svg";
export { ForwardRef as ReactComponent };